import React, { useState, useEffect, useContext } from "react";
import request from "../../../Helpers/API";
import Swal from "sweetalert2";
import Modal from "@mui/material/Modal";

import { LoaderScreen } from "../../components/LoaderScreen";
import { useHistory, useLocation } from "react-router-dom";
import PlantillaScreen from "../../helpers/PlantillaScreen";
import { AnalisisCreditoFiltro } from "../../AnalisisCredito/AnalisisCreditoFiltro";
import { PrestamoClientesFiltro } from "../PrestamoClientes/PrestamoClientesFiltro";
import { FiltroListadoRefacturacion } from "./Filtros/FiltroListadoRefacturacion";

export const RefacturacionListadoScreen = () => {
    const location = useLocation();
    const history = useHistory();
    const [loader, setLoader] = useState({
        mostrar: false,
        alerta: false,
        error: false,
        mensaje: "",
    });

    const [solicitudes, setSolicitudes] = useState({
        tablero: [],
        tabla: [],
        vendedores: [],
        sucursales: [],
    });
    const [filtroAbierto, setFiltroAbierto] = useState(false);

    useEffect(() => {
        setLoader({ ...loader, mostrar: true });
        request
            .get(`RefacturacionCredito/SolicitudesListado`)
            .then((result) => {
                setLoader({ ...loader, mostrar: false });
                setSolicitudes({
                    tablero: result,
                    tabla: result,
                });
            })
            .catch((error) => {
                setLoader({ ...loader, mostrar: false });
                Swal.fire("SOLICITUDES DE CREDITO", JSON.stringify(error), "error");
            });
    }, []);

    const onOpenSolicitud = (folio, cliente) => {
        history.push("/Credito/RefacturacionCredito", {
            folio: folio,
            cliente: cliente,
        });
    };


    //Filtros
    const [filtroRazonSocial, setFiltroRazonSocial] = useState([]);
    const [filtroTipoSolicitud, setFiltroTipoSolicitud] = useState([]);
    const [filtroLineaCredito, setFiltroLineaCredito] = useState([]);
    const [filtroEstado, setFiltroEstado] = useState([]);
    const [filtroSucursal, setFiltroSucursal] = useState([]);
    const [filtroVendedor, setFiltroVendedor] = useState([]);
    const [filtroFolio, setFiltroFolio] = useState([]);

    const onFiltrar = (
        folio,
        asesor,
        cliente,
        sucursal,
        estado,
        tipo_solicitud
    ) => {
        return new Promise((resolve, reject) => {
            var newtabla = solicitudes.tablero;
            //folio
            if (folio != undefined && folio !== null && folio != "") {
                newtabla = newtabla.filter((item) => item.folio === folio);
            } else {
                //Asesor
                if (asesor != undefined && asesor !== null && asesor != "") {
                    newtabla = newtabla.filter((item) => item.vendedor === asesor);
                }
                //Razon Social
                if (
                    cliente != undefined &&
                    cliente !== null &&
                    cliente != ""
                ) {
                    newtabla = newtabla.filter(
                        (item) => item.cliente === cliente
                    );
                }
                //Sucursal
                if (sucursal != undefined && sucursal !== null && sucursal != "") {
                    newtabla = newtabla.filter((item) => item.sucursal === sucursal);
                }
                //Estado
                if (estado != undefined && estado !== null && estado != "") {
                    newtabla = newtabla.filter((item) => item.estado === estado);
                }
                //Tipo de solicitud
                if (
                    tipo_solicitud != undefined &&
                    tipo_solicitud !== null &&
                    tipo_solicitud != ""
                ) {
                    newtabla = newtabla.filter(
                        (item) => item.tipo_credito === tipo_solicitud
                    );
                }
            }
            setSolicitudes({ ...solicitudes, tabla: newtabla });
            resolve("");
            return;
        });
    };
    const RazonSocial = Array.from(
        new Set(solicitudes.tablero.map((item) => item.cliente))
    );

    const TipoSolicitud = Array.from(
        new Set(solicitudes.tablero.map((item) => item.tipo_credito))
    );

    const LineaCredito = Array.from(
        new Set(solicitudes.tablero.map((item) => item.linea_credito))
    );

    const Estado = Array.from(
        new Set(solicitudes.tablero.map((item) => item.estado))
    );

    const Sucursal = Array.from(
        new Set(solicitudes.tablero.map((item) => item.sucursal))
    );

    const Vendedor = Array.from(
        new Set(solicitudes.tablero.map((item) => item.vendedor))
    );

    const Folio = Array.from(
        new Set(solicitudes.tablero.map((item) => item.folio))
    );

    const [openModal, setOpenModal] = useState(false);

    const handleOpenModal = () => {
        setOpenModal(true);
    };

    const handleCloseModal = () => {
        setOpenModal(false);
    };

    const resetFiltros = () => {
        setFiltroRazonSocial([]);
        setFiltroTipoSolicitud([]);
        setFiltroLineaCredito([]);
        setFiltroEstado([]);
        setFiltroSucursal([]);
        setFiltroVendedor([]);
    };

    const capitalizeWords = (str) => {
        return str ? str.toLowerCase().replace(/\b\w/g, (char) => char.toUpperCase()) : "";
    };

    // Contador de solicitudes visibles
    const numeroDeSolicitudes = solicitudes.tabla.length;

    return (
        <PlantillaScreen
            titulo={"LISTADO DE SOLICITUDES CERRADAS"}
            className={"prestamo-clientes-detalle-financiamiento-plantilla"}
            className_main={1}
        >
            <div className="analisis-solicitud-credito">
                <LoaderScreen loader={loader} />

                {solicitudes.tablero === undefined ||
                    solicitudes.tablero === null ||
                    solicitudes.tablero.length === 0 ? (
                    <div></div>
                ) : (
                    <div className="analisis-solicitud-credito-container">
                        <div className="analisis-solicitud-credito-container-filtros">

                            <FiltroListadoRefacturacion
                                tablero={solicitudes.tablero}
                                filtroRazonSocialB={filtroRazonSocial}
                                setFiltroRazonSocialB={setFiltroRazonSocial}
                                filtroTipoSolicitudB={filtroTipoSolicitud}
                                setFiltroTipoSolicitudB={setFiltroTipoSolicitud}
                                filtroLineaCreditoB={filtroLineaCredito}
                                setFiltroLineaCreditoB={setFiltroLineaCredito}
                                filtroEstadoB={filtroEstado}
                                setFiltroEstadoB={setFiltroEstado}
                                filtroSucursalB={filtroSucursal}
                                setFiltroSucursalB={setFiltroSucursal}
                                filtroVendedorB={filtroVendedor}
                                setFiltroVendedorB={setFiltroVendedor}
                                setFiltroFolioB={setFiltroFolio}
                                filtroFolioB={filtroFolio}
                                onFiltrar={onFiltrar}
                            />
                            <div className="contador-solicitudes">
                                Número de operaciones: {numeroDeSolicitudes}
                            </div>
                        </div>
                        <div className="analisis-solicitud-credito-container-table scroll-4">
                            <table cellPadding={0} cellSpacing={0}>
                                <thead>
                                    <tr className="tr-columnas">
                                        <th>SUCURSAL</th>
                                        <th>
                                            <div>CLIENTE</div>
                                        </th>
                                        <th>
                                            <div>ASESOR DE VENTA</div>
                                        </th>
                                        <th>
                                            <div>Tipo de Solicitud</div>
                                        </th>
                                        <th>
                                            <div>FECHA</div>
                                        </th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {solicitudes.tabla.map((item) => (
                                        <tr
                                            onClick={() =>
                                                onOpenSolicitud(item.folio, item.cliente)
                                            }
                                        >
                                            <td>{item.sucursal}</td>
                                            <td>{item.cliente}</td>
                                            <td>{item.vendedor}</td>
                                            <td>{capitalizeWords(item.tipo_credito)}</td>
                                            <td>{item.fecha}</td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                    </div>
                )}
            </div>
        </PlantillaScreen>
    );
};

